export default __webpack_public_path__ + "static/media/assets-article-oliv_02.5c5884f7.jpg";